import { useState, useEffect, useRef } from 'react';
import { checkServerHealth } from '../apiCalls';

const RETRY_INTERVAL = 10000;
const FAILURE_THRESHOLD = 2;

export const useServerHealth = () => {
    const [isServerAvailable, setIsServerAvailable] = useState(true);
    const failureCountRef = useRef(0);

    useEffect(() => {
        let cancelled = false;
        let retryTimer = null;

        const check = async () => {
            try {
                await checkServerHealth();
                if (cancelled) return;
                failureCountRef.current = 0;
                setIsServerAvailable(true);
            } catch {
                if (cancelled) return;
                failureCountRef.current += 1;
                if (failureCountRef.current >= FAILURE_THRESHOLD) {
                    setIsServerAvailable(false);
                }
                retryTimer = setTimeout(check, RETRY_INTERVAL);
            }
        };

        check();
        return () => {
            cancelled = true;
            if (retryTimer) clearTimeout(retryTimer);
        };
    }, []);

    return isServerAvailable;
};
